const defaultImage =
  "https://smartone.s3.amazonaws.com/istockphoto-1298261537-170667a-1659268893198.jpg";
export default defaultImage;
